import React from 'react';

import { FaChevronDown, FaChevronUp } from 'react-icons/fa';
import styled, { css } from 'styled-components';

import {
  CategoryDropdown as BaseCategoryDropdown,
  useProductBrowser,
} from '@techstyle/react-components';

import { getPreservedFilters } from '../../utils/productCategories';

const CategoryDropdownComponent = styled(BaseCategoryDropdown)`
  letter-spacing: ${0.3 / 14}em;
  font-size: 14px;
`;

const linkStyle = css`
  justify-content: center;
  text-align: center;
  color: ${props => props.theme.colors.default};
  box-shadow: inset 0 -1px 0 0 ${props => props.theme.colors.lavender250};
  padding: 18px;

  &&& {
    padding-left: 18px;
  }

  ${props => props.theme.paragraph.variants.paragraph3Uppercase.textStyles};
  color: ${({ theme }) => theme.colors.gunmetal};
  box-shadow: unset;
  border-bottom: 1px solid ${({ theme }) => theme.colors.marble};
  &[data-active-category='true'] {
    color: ${({ theme }) => theme.colors.gunmetal};
    font-weight: 700;
  }
`;

const dropdownStyle = css`
  box-shadow: 0 4px ${({ theme }) => theme.spacing.tiny}px 0
    ${props => props.theme.colors.lightShadow3};
  color: ${props => props.theme.colors.white};
  padding: ${({ theme }) => theme.spacing.tiny}px;
`;

const titleButtonStyle = css`
  font-size: 14px;
  line-height: 1.4;
  letter-spacing: ${0.3 / 14}em;
  color: ${props => props.theme.colors.default};
  background-color: ${props => props.theme.colors.lavender250};

  padding: 15px 0;

  &[aria-expanded='true'] {
    color: ${props => props.theme.colors.white};
    background-color: ${props => props.theme.colors.active};
  }

  &&& {
    box-shadow: none;
  }

  background-color: ${props => props.theme.colors.lavender};
  ${props => props.theme.paragraph.variants.paragraph3Uppercase.textStyles};
`;

const CollapseArrow = styled(FaChevronUp)`
  font-size: 10px;
  margin-left: 4px;
  color: inherit;
`;

const ExpandArrow = styled(FaChevronDown)`
  font-size: 10px;
  margin-left: 4px;
  color: inherit;
`;

function CategoryDropdown(props) {
  const { openOverlay, closeOverlay } = useProductBrowser();

  return (
    <CategoryDropdownComponent
      activeCategoryChecker={category => category.urlPath}
      title={
        <BaseCategoryDropdown.Title
          buttonStyle={titleButtonStyle}
          collapseIcon={CollapseArrow}
          expandIcon={ExpandArrow}
        />
      }
      dropdownStyle={dropdownStyle}
      linkStyle={linkStyle}
      onOpen={openOverlay}
      onClose={closeOverlay}
      preserveFilters={getPreservedFilters}
      {...props}
    />
  );
}

export default CategoryDropdown;
